import { getPricingStartDates } from './pricingHorizon';

const totalPricesByStartDate = (
  circuitDaysPriceByStartDate: (date: Date) => number[],
) =>
  getPricingStartDates().map((startDate) => ({
    price: circuitDaysPriceByStartDate(startDate).reduce((a, b) => a + b, 0),
    date: startDate,
  }));

export const getCircuitTotalPrice = (
  circuitDaysPriceByStartDate: (date: Date) => number[],
) => {
  const totalPriceForDate = totalPricesByStartDate(circuitDaysPriceByStartDate);

  const minimumPrice = Math.min(...totalPriceForDate.map(({ price }) => price));

  return (
    totalPriceForDate.find(({ price }) => price === minimumPrice) ?? {
      price: 0,
      date: new Date(),
    }
  );
};
